import { Button } from '@popsure/dirty-swan';
import { Link } from 'react-router-dom';

import { useSafeTranslation } from '../../../../shared/i18n';
import feathers from '../../assets/feathers.svg';
import styles from './Confirm.module.scss';

export const ConfirmLinkNotFound = () => {
  const { t } = useSafeTranslation();

  return (
    <div
      className={`d-flex ai-center jc-center fd-column ${styles.linkExpiredContainer}`}
    >
      <img className="mb16" src={feathers} alt="Link not found" />
      <h1 className="p-h2">
        {t(
          'updateEmail.updateConfirmation.linkNotFound.title',
          'This link was not found'
        )}
      </h1>
      <div className={`p-p mt8 wmx6 ${styles.linkExpiredDescription}`}>
        {t(
          'updateEmail.updateConfirmation.linkNotFound.description',
          'Make sure you copied the link correctly. If you are still having trouble, please contact us.'
        )}{' '}
      </div>
      <Button className="wmn3 mt24" as={Link} to="/me/account-settings">
        {t(
          'updateEmail.updateConfirmation.goToMyAccount.text',
          'Go to my account'
        )}
      </Button>
    </div>
  );
};
